import * as actionTypes from '../actionType';
const defaultState = {
  isOnline: ''
}
export default {
  isOnline(state = defaultState.isOnline, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.IS_ONLINE:
        return payload;
      default:
    }

    return state;
  }
}